<template>
  <div style="positive: relative">
    <div>
      <div>
        <div class="is-white-ter">
          <div>
            <div class="columns">
              <div class="column is-3" style="border-right: 1px solid #e3e3e3">
                <aside class="menu">
                  <ul class="menu-list" style="margin: 0; list-style: none">
                    <li style="margin-bottom: 12px">
                      <a
                        @click.prevent="
                          () => {
                            getPersonalMedias(true);
                            menu = 0;
                            isDriveStorage = false;
                          }
                        "
                        style="padding: 8px; border-radius: 4px;"
                        :style="
                          menu == 0 ? 'background-color: whitesmoke;' : ''
                        "
                      >
                        <div class="flex-row flex-row-between flex-row-centered">
                          <p class="font-poppins font-18 font-w-500">Personal</p>
                          <p class="font-poppins font-12 has-text-neutralgray3">{{ formatBytes(auth.activePackage.storageLimit) }}</p>
                        </div>
                        <progress
                          class="progress is-primary"
                          :value="personal_storage_used"
                          :max="auth.activePackage.storageLimit"
                          style="margin: 8px 0px; height: 8px;"
                        ></progress>
                        <p class="help has-text-grey" style="margin-top: 0px;">
                          {{ formatBytes(personal_storage_used) }} digunakan
                        </p>
                      </a>
                    </li>
                    <li
                      v-if="
                        !isEmpty(account) &&
                        !isEmpty(account.university.activePackage)
                      "
                      style="margin-bottom: 12px;"
                    >
                      <a
                        @click.prevent="
                          () => {
                            getPTMedias(true);
                            menu = 1;
                            isDriveStorage = false;
                          }
                        "
                        style="padding: 8px; border-radius: 4px;"
                        :style="
                          menu == 1 ? 'background-color: whitesmoke;' : ''
                        "
                      >
                        <div class="flex-row flex-row-between flex-row-centered">
                          <p class="font-poppins font-18 font-w-500">Perguruan Tinggi</p>
                          <p class="font-poppins font-12 has-text-neutralgray3">{{ formatBytes(account.university.activePackage.storageLimit) }}</p>
                        </div>
                        <progress
                          class="progress is-primary"
                          :value="account_storage_used"
                          :max="account.university.activePackage.storageLimit"
                          style="margin: 8px 0px; height: 8px;"
                        ></progress>
                        <p class="help has-text-grey" style="margin-top: 0px;">
                          {{ formatBytes(account_storage_used) }} digunakan
                        </p>
                      </a>
                    </li>
                    <li v-if="!isEmpty(account) && canIntegrationGoogleDrive">
                      <a
                        @click.prevent="
                          () => {
                            getGoogleDriveMedia();
                            menu = 2;
                            isDriveStorage = true;
                          }
                        "
                        style="padding: 8px; border-radius: 4px;"
                        :style="
                          menu == 2 ? 'background-color: whitesmoke;' : ''
                        "
                      >
                        <div class="flex-row flex-row-between flex-row-centered">
                          <p class="font-poppins font-18 font-w-500">Google Drive</p>
                          <p class="font-poppins font-12 has-text-neutralgray3" v-if="isConnectedDrive">{{
                            driveUsage.limit > 0
                            ? formatBytes(driveUsage.limit)
                            : 'Unlimited'
                          }}</p>
                        </div>
                        <progress
                          class="progress is-primary"
                          :value="driveUsage.usage"
                          :max="driveUsage.limit"
                          style="margin: 8px 0px; height: 8px;"
                          v-if="driveUsage.limit > 0"
                        ></progress>
                        <p class="help has-text-grey" :style="driveUsage.limit > 0 ? 'margin-top: 0px;' : 'margin-top: 8px;'" v-if="isConnectedDrive">
                          {{ formatBytes(driveUsage.usage) }} digunakan
                        </p>
                        <p class="help has-text-grey" v-else>
                          Hubungkan akun
                        </p>
                      </a>
                    </li>
                    <li v-if="isEmpty(account)">
                      <button
                        type="button"
                        @click.prevent="() => $router.push('/panel/university')"
                        class="
                          button
                          is-bg-white-ter is-fullwidth
                          tooltip
                          is-tooltip-multiline
                        "
                        style="border: 1px dashed #dbdbdb"
                        data-tooltip="Sambungkan akun perguruan tinggi anda, dan dapatkan penyimpanan lebih besar"
                      >
                        <span class="icon"
                          ><i class="far fa-building"></i
                        ></span>
                        <span
                          ><small class="has-text-grey"
                            >Sambungkan Akun</small
                          ></span
                        >
                      </button>
                    </li>
                  </ul>
                </aside>
              </div>
              <div class="column">
                <p class="title is-5">
                  Penyimpanan
                  {{
                    menu == 0
                      ? "Personal"
                      : menu == 1
                      ? "Perguruan Tinggi"
                      : "Google Drive"
                  }}
                </p>
                <hr />
                <div
                  class="columns is-vcentered"
                  style="border-bottom: 1px solid #e3e3e3"
                >
                  <div class="column" v-if="menu != 2">
                    <media-filter
                      :dataProvider="dataProvider"
                      :clickHandler="getMedias"
                      :loading="
                        loading_get_medias_refresh || loading_get_medias
                      "
                    ></media-filter>
                  </div>
                  <div class="column" v-else-if="isConnectedDrive">
                    <media-filter-google-drive
                      :filterDrive="filterDrive"
                      :folderId="driveFolderId"
                      :clickHandler="getGoogleDriveMedia"
                      :loading="loading_get_drive_refresh || loading_get_drive"
                    ></media-filter-google-drive>
                  </div>
                  <div class="column is-narrow">
                    <button
                      type="button"
                      class="button tooltip is-tooltip-left is-fullwidth"
                      :data-tooltip="`Tambahkan media pada akun ${
                        menu == 0
                          ? 'personal'
                          : menu == 1
                          ? 'perguruan tinggi'
                          : 'Google Drive'
                      }`"
                      :class="{
                        'is-primary': menu == 0,
                        'is-info': menu == 1,
                        'is-darkblue': menu == 2,
                      }"
                      @click.prevent="
                        menu == 0 || menu == 1
                          ? (edit_modal = true)
                          : (modal_upload_drive = true)
                      "
                      :style="
                        menu != 0 && menu != 1
                          ? isConnectedDrive
                            ? ''
                            : 'display: none !important;'
                          : ''
                      "
                    >
                      <span class="icon"><i class="fas fa-plus"></i></span>
                      <span>Tambah</span>
                    </button>
                  </div>
                </div>

                <div
                  style="
                    margin: -12px -16px -12px -12px;
                    padding: 12px;
                    min-height: 60vh;
                    overflow-y: auto;
                    overflow-x: hidden;
                  "
                  v-if="!loading_get_medias_refresh && !isDriveStorage"
                >
                  <div
                    class="columns"
                    v-for="(media, mk) in (menu == 0) ? views : viewsPT"
                    :key="mk"
                    :class="
                      !isEmpty(selected_media) && mk == selected_media.index
                        ? 'selected'
                        : ''
                    "
                  >
                    <div
                      class="column is-12"
                      style="
                        position: relative;
                        border-bottom: 1px solid #e3e3e3;
                      "
                    >
                      <a
                        @click.prevent="selectMedia(mk, media)"
                        @dblclick.prevent="openFolder(mk)"
                        href=""
                      >
                        <div class="columns is-mobile">
                          <div
                            class="column is-narrow"
                            v-if="withSubmit && media.file_type != 'folder'"
                          >
                            <div
                              class="field"
                              style="padding: 0 15px"
                              @click.prevent="markToggle(media.id)"
                            >
                              <input
                                class="is-checkradio"
                                type="checkbox"
                                :checked="
                                  available_ids.indexOf(media.id) > -1
                                    ? true
                                    : false
                                "
                              />
                              <label
                                for="exampleCheckbox"
                                style="padding: 0"
                              ></label>
                            </div>
                          </div>
                          <div class="column is-narrow">
                            <icon-collection :media="media"></icon-collection>
                          </div>
                          <div class="column">
                            <!-- <p class="has-text-grey tooltip" :data-tooltip="media.name">{{ (!isEmpty(media.name) ? media.name : '').substring(0, 10) }}...</p> -->
                            <p
                              class="has-text-dark"
                              style="word-break: break-word"
                            >
                              {{ !isEmpty(media.name) ? media.name : "" }}
                            </p>
                            <p
                              class="has-text-grey"
                              v-if="!isEmpty(media.size)"
                            >
                              <small>{{ formatBytes(media.size) }}</small>
                            </p>
                            <p class="has-text-grey font-12">
                              <small>{{
                                date_humanize(media.created_at)
                              }}</small>
                            </p>
                          </div>
                          <div class="column is-narrow">
                            <div
                              v-if="
                                media.file_type != 'folder' &&
                                !isEmpty(selected_media) &&
                                mk == selected_media.index
                              "
                              class="
                                button-setting
                                right
                                dropdown
                                is-right is-hoverable
                              "
                              style="margin-right: 13px"
                            >
                              <div class="dropdown-trigger">
                                <button
                                  type="button"
                                  class="button is-small"
                                  aria-haspopup="true"
                                  aria-controls="dropdown-menu2"
                                >
                                  <span><i class="fas fa-ellipsis-v"></i></span>
                                </button>
                              </div>
                              <div
                                class="dropdown-menu"
                                id="dropdown-menu2"
                                role="menu"
                              >
                                <div class="dropdown-content has-text-left">
                                  <a
                                    class="dropdown-item"
                                    @click.prevent="preview(media)"
                                    v-if="
                                      preview_types.indexOf(media.type) > -1
                                    "
                                  >
                                    <i class="fa fa-eye"></i>&nbsp;Preview
                                  </a>
                                  <a
                                    @click.prevent="download(selected_media)"
                                    class="dropdown-item"
                                    v-if="
                                      [
                                        'image',
                                        'video',
                                        'document',
                                        'other',
                                      ].indexOf(media.type) > -1
                                    "
                                  >
                                    <i class="fa fa-download"></i>&nbsp;Unduh
                                  </a>
                                  <hr
                                    class="dropdown-divider"
                                    v-if="!isEmpty(account) && menu == 1"
                                  />
                                  <a
                                    @click.prevent="
                                      moveTo(media.id, 'personal')
                                    "
                                    class="dropdown-item"
                                    v-if="!isEmpty(account) && menu == 1"
                                  >
                                    <i class="fa fa-arrow-right"></i
                                    >&nbsp;Pindahkan ke Penyimpanan Personal
                                  </a>
                                  <hr
                                    class="dropdown-divider"
                                    v-if="!isEmpty(account) && menu == 0"
                                  />
                                  <a
                                    @click.prevent="moveTo(media.id, 'account')"
                                    class="dropdown-item"
                                    v-if="!isEmpty(account) && menu == 0"
                                  >
                                    <i class="fa fa-arrow-right"></i
                                    >&nbsp;Pindahkan ke Penyimpanan Perguruan
                                    Tinggi
                                  </a>
                                  <hr class="dropdown-divider" />
                                  <a
                                    class="dropdown-item has-text-danger"
                                    @click.prevent="removeMedia"
                                  >
                                    <i class="fa fa-trash"></i>&nbsp;Hapus
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div v-if="(menu === 0 && views.length === 0) || (menu === 1 && viewsPT.length === 0)">
                    <p class="has-text-grey has-text-centered">
                      Data tidak ditemukan.
                    </p>
                  </div>
                  <div v-if="loading_get_medias || loading_get_medias_refresh">
                    <spinner-loading></spinner-loading>
                  </div>
                  <pagination
                    v-if="!loading_get_medias && views.length > 0"
                    :dataProvider="dataProvider"
                    :clickHandler="getMedias"
                    :infinity_scroll="true"
                  ></pagination>
                </div>

                <div
                  style="
                    margin: -12px -16px -12px -12px;
                    padding: 12px;
                    min-height: 60vh;
                    overflow-y: auto;
                    overflow-x: hidden;
                  "
                  v-if="!loading_get_medias_refresh && isDriveStorage"
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      flex: 1;
                      align-items: center;
                      margin-top: 7rem;
                    "
                    v-if="!isConnectedDrive"
                  >
                  <p class="font-14" style="text-align: center; margin-bottom:2rem;">Akun EdLink Anda belum terhubung dengan Google Drive. Silakan atur sambungan dengan Google Drive.</p>

                  <nuxt-link :to="{ path: '/panel/profile', query: { menu: 4 } }" class="button is-primary">
                    <span class="icon" style="margin-right: 0.5rem">
                      <i class="fas fa-cog"></i>
                    </span> Atur Sambungan ke Google Drive</nuxt-link>
                  </div>
                  <div
                    class="columns"
                    v-for="(media, mk) in driveMedia"
                    :key="mk"
                    :class="
                      !isEmpty(selected_media) && mk == selected_media.index
                        ? 'selected'
                        : ''
                    "
                  >
                    <div
                      class="column is-12"
                      style="
                        position: relative;
                        border-bottom: 1px solid #e3e3e3;
                      "
                    >
                      <a
                        @click.prevent="selectMedia(mk, media)"
                        @dblclick.prevent="getGoogleDriveMedia(media.id, false)"
                        href=""
                      >
                        <div class="columns is-mobile">
                          <div
                            class="column is-narrow"
                            v-if="
                              withSubmit &&
                              media.type !=
                                'application/vnd.google-apps.folder' &&
                              media.type != 'back'
                            "
                          >
                            <div
                              class="field"
                              style="padding: 0 15px"
                              @click.prevent="selectDriveMedia(media.id)"
                            >
                              <input
                                class="is-checkradio"
                                type="checkbox"
                                :checked="
                                  selected_ids_drive.indexOf(media.id) > -1
                                    ? true
                                    : false
                                "
                              />
                              <label
                                for="exampleCheckbox"
                                style="padding: 0"
                              ></label>
                            </div>
                          </div>
                          <div class="column is-narrow">
                            <icon-collection :media="media" :storageType="'google_drive'"></icon-collection>
                          </div>
                          <div class="column">
                            <p
                              class="has-text-dark"
                              style="word-break: break-word"
                            >
                              {{ !isEmpty(media.name) ? media.name : "" }}
                            </p>
                          </div>
                          <div class="column is-narrow">
                            <div
                              v-if="
                                media.type !=
                                  'application/vnd.google-apps.folder' &&
                                media.type != 'back' &&
                                !isEmpty(selected_media) &&
                                mk == selected_media.index
                              "
                              class="
                                button-setting
                                right
                                dropdown
                                is-right is-hoverable
                              "
                              style="margin-right: 13px"
                            >
                              <div class="dropdown-trigger">
                                <button
                                  type="button"
                                  class="button is-small"
                                  aria-haspopup="true"
                                  aria-controls="dropdown-menu2"
                                >
                                  <span><i class="fas fa-ellipsis-v"></i></span>
                                </button>
                              </div>
                              <div
                                class="dropdown-menu"
                                id="dropdown-menu2"
                                role="menu"
                              >
                                <div class="dropdown-content has-text-left">
                                  <a
                                    class="dropdown-item"
                                    @click.prevent="preview(media, true)"
                                    v-if="media.file_type != 'folder'"
                                  >
                                    <i class="fa fa-eye"></i>&nbsp;Preview
                                  </a>
                                  <a
                                    @click.prevent="
                                      downloadFromIntegration(media)
                                    "
                                    class="dropdown-item"
                                    v-if="
                                      media.file_type != 'folder' &&
                                      media.shared
                                    "
                                  >
                                    <i class="fa fa-download"></i>&nbsp;Unduh
                                  </a>
                                  <hr class="dropdown-divider" />
                                  <a
                                    class="dropdown-item has-text-danger"
                                    @click.prevent="
                                      removeDriveMedia(media, false)
                                    "
                                  >
                                    <i class="fa fa-trash"></i>&nbsp;Hapus
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    v-if="
                      isDriveStorage && driveMedia.length <= 0 &&
                      (!loading_get_medias || !loading_get_drive_refresh)
                    "
                  >
                    <p
                      class="has-text-grey has-text-centered"
                      v-if="isConnectedDrive"
                    >
                      Data tidak ditemukan.
                    </p>
                  </div>
                  <div v-if="isConnectedDrive && (loading_get_drive || loading_get_drive_refresh)">
                    <spinner-loading></spinner-loading>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <br />

    <!-- <hr v-if="withSubmit" style="margin-bottom: 0;"> -->

    <div
      class="box"
      v-if="withSubmit"
      style="
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        width: 100%;
        border-radius: 0;
      "
    >
      <div class="buttons is-pulled-right">
        <button
          class="button is-text"
          @click.prevent="onClickCancel"
          style="margin-right: 10px">
          Batal
        </button>

        <button
          class="button is-info"
          @click.prevent="submitSelected"
          :disabled="
            (available_ids.length <= 0 && selected_ids_drive.length <= 0) ||
            is_loading_btn
          "
          style="margin-right: 10px"
          :class="{ 'is-loading': is_loading_btn }"
        >
          <span>
            Pilih <span v-if="available_ids.length > 0 || selected_ids_drive.length > 0">{{ available_ids.length + selected_ids_drive.length }} Item</span>
          </span>
        </button>
      </div>
    </div>

    <b-modal v-if="!isEmpty(selected_media) && is_preview" :active="true">
      <img
        v-if="selected_media.type == 'image'"
        :src="selected_media.original_url"
        alt=""
      />

      <div
        v-else-if="video_types.indexOf(selected_media.type) > -1"
        style="padding: 50px"
      >
        <div class="image is-16by9" style="padding: 0">
          <video-manager :videos="[selected_media]"></video-manager>
        </div>
      </div>

      <button
        class="modal-close is-large"
        aria-label="close"
        @click.prevent="is_preview = false"
      ></button>
    </b-modal>

    <b-modal
      v-if="show_message"
      :active.sync="show_message"
      :can-cancel="false"
      style="padding: 15px"
      :width="500"
    >
      <div class="box is-boxed-3">
        <div class="columns is-gapless">
          <div class="column has-text-right">
            <button class="button is-white" @click.prevent="show_message = false">
              <span class="icon" style="width: 11px;">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.16663 1.16666L6.99996 6.99999M6.99996 6.99999L12.8333 12.8333M6.99996 6.99999L12.8333 1.16666M6.99996 6.99999L1.16663 12.8333" stroke="#2B45A2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </button>
          </div>
        </div>

        <div class="columns is-gapless" style="margin: 0 -17px;">
          <div class="column has-text-centered">
            <img src="/assets/img/redcross.svg" alt="" style="margin-bottom: 16px;">

            <div style="margin: 0 17px;">
              <p class="font-w-600 font-20" style="margin-bottom: 4px;">{{ menu === 1 ? "Penyimpanan Perguruan Tinggi" : "Penyimpanan personal" }} telah mencapai batas</p>
              <p class="font-w-400 font-16 has-text-grey" style="margin-bottom: 16px;">Akun Anda sudah mencapai batas penyimpanan yang ditentukan ({{ formatBytes(menu === 1 ? account.university.activePackage.storageLimit : auth.activePackage.storageLimit) }}). <br>Silakan upgrade akun Anda ke EdLink Pro.</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal Storage Edlink -->
    <b-modal :active.sync="edit_modal" has-modal-card>
      <div class="modal-card upload-modal">
        <header class="modal-card-head is-bg-primary">
          <p class="modal-card-title has-text-white">Tambah Media</p>
        </header>
        <section class="modal-card-body" style="padding: 0">
          <b-tabs v-model="tab">
            <b-tab-item label="Upload" icon="cloud-upload">
              <b-field>
                <b-upload
                  drag-drop
                  style="width: 100%"
                  @input="uploadingFile"
                  :loading="loading_upload"
                  :disabled="loading_upload"
                  accept="
                    application/pdf,.ppt,.pptx,.doc,.docx,.xlsx,.xls,.zip, image/*,.mp4,.mbz,.txt,.myo,.rar
                  "
                >
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large"> </b-icon>
                      </p>
                      <p style="margin-bottom: 0">
                        Drop your files here or click to upload
                      </p>
                      <p class="help has-text-grey">
                        <small>(Tipe berkas yang dapat di unggah: pdf, ppt, pptx, xls, xlsx, doc, docx, mp4, youtube, rar dan zip & Maksimal 100MB)</small>
                      </p>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <div class="columns" v-if="!isEmpty(progress_upload)">
                <div class="column">
                  <progress
                    class="progress is-success"
                    :value="progress_upload"
                    max="100"
                  ></progress>
                </div>
                <div class="column is-narrow">{{ progress_upload }}%</div>
              </div>
            </b-tab-item>

            <b-tab-item label="Youtube" icon="youtube">
              <form @submit.prevent="addMedia">
                <b-field label="URL">
                  <b-input
                    type="text"
                    placeholder="e.g: https://..."
                    v-model="new_media.link"
                  ></b-input>
                </b-field>

                <b-field label="Label">
                  <b-input
                    type="text"
                    placeholder="e.g: Youtube"
                    v-model="new_media.name"
                  ></b-input>
                </b-field>

                <button
                  type="submit"
                  class="button is-primary"
                  :class="{ 'is-loading': loading_create_media }"
                  :disabled="loading_create_media"
                >
                  Simpan
                </button>
              </form>
            </b-tab-item>
          </b-tabs>
        </section>
      </div>
    </b-modal>

    <!-- Modal Google Drive -->

    <b-modal :active.sync="modal_upload_drive" has-modal-card>
      <div class="modal-card upload-modal">
        <header class="modal-card-head is-bg-primary">
          <p class="modal-card-title has-text-white">Upload Google Drive</p>
        </header>
        <section class="modal-card-body" style="padding: 0">
          <b-tabs v-model="tab">
            <b-tab-item label="Upload" icon="cloud-upload">
              <b-field>
                <b-upload
                  drag-drop
                  style="width: 100%"
                  @input="uploadingFileDrive"
                  :loading="loading_upload"
                  :disabled="loading_upload"
                  accept="
                    application/pdf,.ppt,.pptx,.doc,.docx,.xlsx,.xls,.zip, image/*,.mp4,.mbz,.txt,.myo,.rar
                  "
                >
                  <section class="section">
                    <div class="content has-text-centered">
                      <p>
                        <b-icon icon="upload" size="is-large"> </b-icon>
                      </p>
                      <p style="margin-bottom: 0">
                        Drop your files here or click to upload
                      </p>
                      <p class="help has-text-grey">
                        <small>(Tipe berkas yang dapat di unggah: pdf, ppt, pptx, xls, xlsx, doc, docx, mp4, youtube, rar dan zip & Maksimal 100MB)</small>
                      </p>
                    </div>
                  </section>
                </b-upload>
              </b-field>

              <div class="columns" v-if="!isEmpty(progress_upload)">
                <div class="column">
                  <progress
                    class="progress is-success"
                    :value="progress_upload"
                    max="100"
                  ></progress>
                </div>
                <div class="column is-narrow">{{ progress_upload }}%</div>
              </div>
            </b-tab-item>
          </b-tabs>
        </section>
      </div>
    </b-modal>

    <b-modal
      :active.sync="message_modal_show"
      :width="640"
      scroll="keep"
      v-if="!isEmpty(error_delete_data)"
    >
      <div class="card" style="border-radius: 8px">
        <div class="card-content" style="padding: 16px">
          <div
            class="columns"
            :style="show_error_detail ? 'margin-bottom: 0;' : ''"
          >
            <div class="column is-narrow"></div>
            <div class="column has-text-centered">
              <p
                v-if="!show_error_detail"
                style="margin-top: 15px"
                class="title font-20 font-w-600 has-text-darkblue"
              >
                {{
                  !isEmpty(error_delete_data.totalUsed) &&
                  error_delete_data.totalUsed > 0
                    ? "Gagal menghapus berkas..."
                    : "Berhasil!"
                }}
              </p>
            </div>
            <div class="column is-narrow">
              <a href="" @click.prevent="message_modal_show = false"
                ><b-icon icon="close"></b-icon
              ></a>
            </div>
          </div>

          <div>
            <div v-if="!show_error_detail">
              <div class="has-text-centered" style="margin-bottom: 15px">
                <svg
                  width="80"
                  height="76"
                  viewBox="0 0 80 76"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M78.3378 57.9928L50.0776 6.04338C45.5372 -1.60053 34.4689 -1.61068 29.9223 6.04338L1.66359 57.9928C-2.97797 65.8035 2.64156 75.6945 11.7389 75.6945H68.2601C77.3498 75.6945 82.9794 65.8115 78.3378 57.9928ZM40 66.3195C37.4159 66.3195 35.3125 64.216 35.3125 61.632C35.3125 59.0479 37.4159 56.9445 40 56.9445C42.5841 56.9445 44.6875 59.0479 44.6875 61.632C44.6875 64.216 42.5841 66.3195 40 66.3195ZM44.6875 47.5695C44.6875 50.1535 42.5841 52.257 40 52.257C37.4159 52.257 35.3125 50.1535 35.3125 47.5695V24.132C35.3125 21.5479 37.4159 19.4445 40 19.4445C42.5841 19.4445 44.6875 21.5479 44.6875 24.132V47.5695Z"
                    fill="#FFAD23"
                  />
                </svg>
              </div>

              <p
                class="has-text-darkblue has-text-centered font-16"
                style="margin-bottom: 35px"
              >
                Berkas dipakai
                <strong>{{ error_delete_data["totalUsed"] }} data lain</strong>
              </p>
              <button
                class="button is-darkblue is-fullwidth font-w-600 font-16"
                @click.prevent="show_error_detail = true"
              >
                Lihat detail
              </button>
            </div>

            <div v-else>
              <div v-if="!isEmpty(error_delete_data.usedPosts)">
                <p
                  class="title font-16 font-w-600 has-text-dark"
                  style="margin-bottom: 12px"
                >
                  Postingan yang memakai berkas ini
                </p>
                <ul>
                  <li
                    v-for="(p, k) in error_delete_data.usedPosts"
                    :key="k"
                    :style="
                      k != error_delete_data.usedPosts.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column is-narrow">
                        <i class="fas fa-angle-right"></i>&nbsp;&nbsp;
                      </div>
                      <div class="column">
                        <p>
                          <nuxt-link
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else-if="p.type == '1'"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-groupteams-groupteams_id-learningmaterial_id'
                                  : 'panel-groups-id-groupteams-groupteams_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                groupteams_id: p.classTeamId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-12">
                          <span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }} - </span
                          >Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <hr
                v-if="!isEmpty(error_delete_data.usedTeacherQuestionAnswers)"
                style="
                  margin: 0 -16px 20px;
                  background-color: #e2e7ff;
                  height: 1px;
                "
              />
              <div
                v-if="!isEmpty(error_delete_data.usedTeacherQuestionAnswers)"
              >
                <p
                  class="title font-16 font-w-600 has-text-dark"
                  style="margin-bottom: 12px"
                >
                  Jawaban tugas yang memakai berkas ini
                </p>
                <ul>
                  <li
                    v-for="(
                      p, k
                    ) in error_delete_data.usedTeacherQuestionAnswers"
                    :key="k"
                    :style="
                      k !=
                      error_delete_data.usedTeacherQuestionAnswers.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column is-narrow">
                        <i class="fas fa-angle-right"></i>&nbsp;&nbsp;
                      </div>
                      <div class="column">
                        <p>
                          <nuxt-link
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else-if="p.type == '1'"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-groupteams-groupteams_id-learningmaterial_id'
                                  : 'panel-groups-id-groupteams-groupteams_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                groupteams_id: p.classTeamId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-12">
                          <span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }} - </span
                          >Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <hr
                v-if="!isEmpty(error_delete_data.usedQuizQuestions)"
                style="
                  margin: 20px -16px;
                  background-color: #e2e7ff;
                  height: 1px;
                "
              />
              <div v-if="!isEmpty(error_delete_data.usedQuizQuestions)">
                <p
                  class="title font-16 font-w-600 has-text-dark"
                  style="margin-bottom: 12px"
                >
                  Soal Quiz yang memakai berkas ini
                </p>
                <ul>
                  <li
                    v-for="(p, k) in error_delete_data.usedQuizQuestions"
                    :key="k"
                    :style="
                      k != error_delete_data.usedQuizQuestions.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column is-narrow">
                        <i class="fas fa-angle-right"></i>&nbsp;&nbsp;
                      </div>
                      <div class="column">
                        <p>
                          <nuxt-link
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else-if="p.type == '1'"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-groupteams-groupteams_id-learningmaterial_id'
                                  : 'panel-groups-id-groupteams-groupteams_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                groupteams_id: p.classTeamId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-12">
                          <span v-if="!isEmpty(p.quizQuestionOrder)"
                            >Soal no {{ p.quizQuestionOrder + 1 }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }} - </span
                          >Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <hr
                v-if="!isEmpty(error_delete_data.usedPosts)"
                style="
                  margin: 20px -16px;
                  background-color: #e2e7ff;
                  height: 1px;
                "
              />

              <button
                class="
                  button
                  is-primary3
                  has-text-darkblue
                  is-fullwidth
                  font-w-500 font-16
                "
                @click.prevent="message_modal_show = false"
                style="margin-top: 15px"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      :active.sync="message_force_modal_show"
      :width="640"
      scroll="clip"
      v-if="!isEmpty(error_delete_data)"
      has-modal-card
    >
      <div class="modal-card" style="width: auto">
        <header
          class="modal-card-head has-text-centered has-background-white"
          style="border: none"
        >
          <div class="modal-card-title">
            <p class="title font-20" style="margin-bottom: 16px">
              Apakah yakin hapus berkas ini?
            </p>
            <p class="font-16" style="color: #666666">
              Berkas ini pernah Anda lampirkan di
              {{ error_delete_data.totalUsed }}<br />post pada semester
              sebelumnya.
            </p>
          </div>
        </header>
        <section class="modal-card-body" style="padding: 32px">
          <div>
            <div>
              <div v-if="!isEmpty(error_delete_data.usedPosts)">
                <ul>
                  <li
                    v-for="(p, k) in error_delete_data.usedPosts"
                    :key="k"
                    :style="
                      k != error_delete_data.usedPosts.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="columns is-font-14 has-text-darkblue is-mobile"
                      style="margin-bottom: 0"
                    >
                      <div class="column">
                        <p>
                          <nuxt-link
                            class="has-text-dark font-16 font-w-500"
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          <span v-if="!isEmpty(p.classPeriodeLabel)"
                            >Th. {{ p.classPeriodeLabel }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }}</span
                          >
                        </p>
                      </div>
                      <div class="column is-narrow">
                        <div
                          v-if="p.type === 'Z'"
                          class="
                            tag
                            is-lightprimary
                            has-text-primary
                            font-w-500 font-14
                          "
                        >
                          Quiz
                        </div>
                        <div
                          v-else-if="p.type === 'M'"
                          class="
                            tag
                            is-primary5
                            has-text-primary6
                            font-w-500 font-14
                          "
                        >
                          Materi
                        </div>
                        <div
                          v-else-if="p.type === 'Q'"
                          class="tag font-w-500 font-14"
                          style="background: #fff9dd; color: #ffa000"
                        >
                          Tugas
                        </div>
                        <div
                          v-else-if="p.type === 'V'"
                          class="tag is-info font-w-500 font-14"
                        >
                          Conference
                        </div>
                      </div>
                    </div>

                    <hr
                      style="
                        margin: 1px 0;
                        background-color: rgba(0, 0, 0, 0.12);
                        height: 1px;
                      "
                    />
                  </li>
                </ul>
              </div>

              <div
                v-if="!isEmpty(error_delete_data.usedTeacherQuestionAnswers)"
              >
                <ul>
                  <li
                    v-for="(
                      p, k
                    ) in error_delete_data.usedTeacherQuestionAnswers"
                    :key="k"
                    :style="
                      k !=
                      error_delete_data.usedTeacherQuestionAnswers.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column">
                        <p>
                          <nuxt-link
                            class="has-text-dark font-16 font-w-500"
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          <span v-if="!isEmpty(p.classPeriodeLabel)"
                            >Th. {{ p.classPeriodeLabel }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }}</span
                          >
                        </p>
                      </div>
                    </div>

                    <hr
                      style="
                        margin: 1px 0;
                        background-color: rgba(0, 0, 0, 0.12);
                        height: 1px;
                      "
                    />
                  </li>
                </ul>
              </div>

              <div v-if="!isEmpty(error_delete_data.usedQuizQuestions)">
                <ul>
                  <li
                    v-for="(p, k) in error_delete_data.usedQuizQuestions"
                    :key="k"
                    :style="
                      k != error_delete_data.usedQuizQuestions.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column">
                        <p>
                          <nuxt-link
                            class="has-text-dark font-16 font-w-500"
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          <span v-if="!isEmpty(p.classPeriodeLabel)"
                            >Th. {{ p.classPeriodeLabel }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }} - </span
                          ><span v-if="!isEmpty(p.quizQuestionOrder)"
                            >Soal No. {{ p.quizQuestionOrder + 1 }}</span
                          >
                        </p>
                      </div>
                    </div>

                    <hr
                      style="
                        margin: 1px 0;
                        background-color: rgba(0, 0, 0, 0.12);
                        height: 1px;
                      "
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <footer
          class="modal-card-foot has-background-white"
          style="padding: 20px 32px; border: none"
        >
          <button
            class="
              button
              is-outlined is-brightred is-fullwidth
              font-w-600 font-16
            "
            :class="{ 'is-disabled': loading_remove_media }"
            @click.prevent="message_force_modal_show = false"
            style="padding: 16px 32px; height: auto; margin-right: 20px"
          >
            Batal
          </button>
          <button
            class="
              button
              is-brightred
              has-text-white
              is-fullwidth
              font-w-600 font-16
            "
            :class="{
              'is-loading': loading_remove_media,
              'is-disabled': loading_remove_media,
            }"
            @click.prevent="removeMedia($event, true)"
            style="padding: 16px 32px; height: auto"
          >
            Ya, Hapus
          </button>
        </footer>
      </div>
      <!-- <div class="card" style="border-radius: 8px;">
        <div class="card-content" style="padding: 32px;">

        </div>
      </div> -->
    </b-modal>

    <!-- Modal force delete google drive -->
    <b-modal
      :active.sync="message_force_modal_drive_show"
      :width="640"
      scroll="clip"
      v-if="!isEmpty(error_delete_drive_data)"
      has-modal-card
    >
      <div class="modal-card" style="width: auto">
        <header
          class="modal-card-head has-text-centered has-background-white"
          style="border: none"
        >
          <div class="modal-card-title">
            <p class="title font-20" style="margin-bottom: 16px">
              Apakah yakin hapus berkas ini?
            </p>
            <p class="font-16" style="color: #666666">
              Berkas ini pernah Anda lampirkan di
              {{ error_delete_drive_data.totalUsed }}<br />post pada semester
              sebelumnya.
            </p>
          </div>
        </header>
        <section class="modal-card-body" style="padding: 32px">
          <div>
            <div>
              <div v-if="!isEmpty(error_delete_drive_data.usedPosts)">
                <ul>
                  <li
                    v-for="(p, k) in error_delete_drive_data.usedPosts"
                    :key="k"
                    :style="
                      k != error_delete_drive_data.usedPosts.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="columns is-font-14 has-text-darkblue is-mobile"
                      style="margin-bottom: 0"
                    >
                      <div class="column">
                        <p>
                          <nuxt-link
                            class="has-text-dark font-16 font-w-500"
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          <span v-if="!isEmpty(p.classPeriodeLabel)"
                            >Th. {{ p.classPeriodeLabel }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }}</span
                          >
                        </p>
                      </div>
                      <div class="column is-narrow">
                        <div
                          v-if="p.type === 'Z'"
                          class="
                            tag
                            is-lightprimary
                            has-text-primary
                            font-w-500 font-14
                          "
                        >
                          Quiz
                        </div>
                        <div
                          v-else-if="p.type === 'M'"
                          class="
                            tag
                            is-primary5
                            has-text-primary6
                            font-w-500 font-14
                          "
                        >
                          Materi
                        </div>
                        <div
                          v-else-if="p.type === 'Q'"
                          class="tag font-w-500 font-14"
                          style="background: #fff9dd; color: #ffa000"
                        >
                          Tugas
                        </div>
                        <div
                          v-else-if="p.type === 'V'"
                          class="tag is-info font-w-500 font-14"
                        >
                          Conference
                        </div>
                      </div>
                    </div>

                    <hr
                      style="
                        margin: 1px 0;
                        background-color: rgba(0, 0, 0, 0.12);
                        height: 1px;
                      "
                    />
                  </li>
                </ul>
              </div>

              <div
                v-if="
                  !isEmpty(error_delete_drive_data.usedTeacherQuestionAnswers)
                "
              >
                <ul>
                  <li
                    v-for="(
                      p, k
                    ) in error_delete_drive_data.usedTeacherQuestionAnswers"
                    :key="k"
                    :style="
                      k !=
                      error_delete_drive_data.usedTeacherQuestionAnswers
                        .length -
                        1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column">
                        <p>
                          <nuxt-link
                            class="has-text-dark font-16 font-w-500"
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          <span v-if="!isEmpty(p.classPeriodeLabel)"
                            >Th. {{ p.classPeriodeLabel }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }}</span
                          >
                        </p>
                      </div>
                    </div>

                    <hr
                      style="
                        margin: 1px 0;
                        background-color: rgba(0, 0, 0, 0.12);
                        height: 1px;
                      "
                    />
                  </li>
                </ul>
              </div>

              <div v-if="!isEmpty(error_delete_drive_data.usedQuizQuestions)">
                <ul>
                  <li
                    v-for="(p, k) in error_delete_drive_data.usedQuizQuestions"
                    :key="k"
                    :style="
                      k != error_delete_drive_data.usedQuizQuestions.length - 1
                        ? 'margin-bottom: 10px;'
                        : ''
                    "
                  >
                    <div
                      class="
                        columns
                        is-gapless
                        font-14
                        has-text-darkblue
                        is-mobile
                      "
                      style="margin-bottom: 0"
                    >
                      <div class="column">
                        <p>
                          <nuxt-link
                            class="has-text-dark font-16 font-w-500"
                            v-if="['M', 'Q', 'Z', 'V'].indexOf(p.type) > -1"
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-sections-section_id-learningmaterial_id'
                                  : 'panel-groups-id-sections-section_id-learningmaterial_id',
                              params: {
                                id: p.classId,
                                section_id: p.sectionId,
                                learningmaterial_id: p.postId,
                              },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                          <nuxt-link
                            v-else
                            :to="{
                              name:
                                p.classType == 'A'
                                  ? 'panel-classes-id-post_id'
                                  : 'panel-groups-id-post_id',
                              params: { id: p.classId, post_id: p.postId },
                            }"
                            >{{ p.title }}</nuxt-link
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          Kelas {{ p.className }}
                          <span v-if="!isEmpty(p.classCode)"
                            >({{ p.classCode }})</span
                          >
                        </p>
                        <p class="has-text-grey font-14">
                          <span v-if="!isEmpty(p.classPeriodeLabel)"
                            >Th. {{ p.classPeriodeLabel }} - </span
                          ><span v-if="!isEmpty(p.sectionMeet)"
                            >Sesi {{ p.sectionMeet }} - </span
                          ><span v-if="!isEmpty(p.quizQuestionOrder)"
                            >Soal No. {{ p.quizQuestionOrder + 1 }}</span
                          >
                        </p>
                      </div>
                    </div>

                    <hr
                      style="
                        margin: 1px 0;
                        background-color: rgba(0, 0, 0, 0.12);
                        height: 1px;
                      "
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <b-message type="is-warning" style="margin-top: 20px"
            >File yang dihapus dari penyimpanan Google Drive akan bertahan
            selama 30 hari di menu Trash Google Drive</b-message
          >
        </section>
        <footer
          class="modal-card-foot has-background-white"
          style="padding: 20px 32px; border: none"
        >
          <button
            class="button is-outlined is-fullwidth font-w-600 font-16"
            :class="{ 'is-disabled': loading_remove_media }"
            @click.prevent="message_force_modal_drive_show = false"
            style="padding: 16px 32px; height: auto; margin-right: 20px"
          >
            Batal
          </button>
          <button
            class="
              button
              is-brightred
              has-text-white
              is-fullwidth
              font-w-600 font-16
            "
            :class="{
              'is-loading': loading_remove_media,
              'is-disabled': loading_remove_media,
            }"
            @click.prevent="removeDriveMedia(null, true)"
            style="padding: 16px 32px; height: auto"
          >
            Ya, Hapus
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { MEDIA, MESSAGE, UNIVERSITY } from "~/consts";
import VideoManager from "~/components/VideoManager";

export default {
  components: {
    VideoManager,
  },

  props: {
    mediaCatcher: {
      type: Function,
      default: () => {},
    },
    withSubmit: {
      type: Boolean,
      default: true,
    },
    selected_ids: {
      type: Array,
      default: () => [],
    },
    only_extensions: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    types: {
      type: Array,
      default: () => [],
    },
    max: {
      type: [Number, String],
      default: null,
    },
    onClickCancel: {
      type: Function,
      default: () => {},
    },
    open: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      auth: (state) => state.auth,
      account: (state) => state.auth.active_pt,
      account_pt: (state) => state.auth.active_pt.university,
      personal_storage_used: (state) => state.personal_storage_used,
      account_storage_used: (state) => state.account_storage_used,
      active_package_has_been_taken: state => state.active_package_has_been_taken,
      has_lead_warning: function (state) {
        const account = state.auth.active_pt;
        if (!this.isEmpty(account)) {
          return (
            (this.hasLead
              ? this.isLead
              : account.type == "ADMIN" || account.type == "LECTURER") &&
            ["LECTURER", "ADMIN"].indexOf(account.type) > -1
          );
        }
        return false;
      },
    }),
    available_ids() {
      return collect(this.selected_medias)
        .pluck("id")
        .merge(this.selected_ids_clone)
        .toArray();
    },
    available_medias() {
      const personalMedias = collect(this.medias).whereIn("id", this.available_ids).toArray()
      const ptMedias = collect(this.PTMedias).whereIn("id", this.available_ids).toArray()
      return collect(personalMedias).merge(ptMedias).toArray()
    },
    selected_media_drive() {
      return collect(this.driveMedia)
        .whereIn("id", this.selected_ids_drive)
        .toArray();
    },
    upload_failed() {
      return this.is_upload_failed ? "Gagal mengunggah File, " : "";
    },
    isConnectedDrive() {
      return this.auth.driveEmail != null
    },
    canIntegrationGoogleDrive() {
      return (
        this.auth.activeAccount.permissionNames.includes(
          "can_integrate_google_drive"
        ) === true && this.isEmpty(this.$cookies.get("token_temp"))
      );
    },
  },

  watch: {
    account(university) {
      this.getMedias(true);
    },
    only_extensions() {
      this.views = this.medias;
    },
    types() {
      this.views = this.medias;
    },
    selected_ids(val) {
      this.selected_ids_clone = _.clone(val);
    },
    message_modal_show(val) {
      if (!val) {
        this.show_error_detail = false;
        this.error_delete_data = null;
      }
    },
  },

  mounted() {
    if (this.active_package_has_been_taken === false) {
      this.$store.dispatch('getStorageUsed');
    }

    this.getMedias(true, true);
    if (this.isConnectedDrive) {
      this.getGoogleDriveUsage();
      this.parseDriveSelected();
      if (this.selected_ids.length > 0) {
        this.getGoogleDriveMedia();
      }
    }
  },

  data() {
    return {
      edit_modal: false,
      show_message: false,
      show_upgrade: false,
      sending_message: false,
      message_warning: "",
      menu: 0,
      video_types: ["video", "youtube"],
      selected_media: null,
      selected_medias: [],
      active_media: null,
      loading_get_medias_refresh: false,
      loading_get_medias: false,
      loading_create_media: false,
      loading_upload: false,
      tab: 0,
      file_upload: {
        name: "",
        size: "",
      },
      tabs: ["Upload", "Library"],
      medias: [],
      PTMedias: [],
      dataProvider: {
        criterion: [{ criteria: "name", operator: "LK", value: "" }],
        page: {
          current: 1,
        },
        sort: [{ criteria: "created_at", order: "desc" }],
      },
      views: [],
      viewsPT: [],
      is_preview: false,
      new_media: {
        name: "",
        link: "",
      },
      preview_types: ["image", "video", "youtube", "document", "link"],
      progress_upload: null,
      selected_ids_clone: _.clone(this.selected_ids),
      files: [],
      detail_quota_pt_used: {
        storage_used: 0,
        class_used: 0,
        conference_used: 0,
        storage_detail: 0,
      },
      loading_detail_quota_pt_used: false,
      show_detail: false,
      remaining_personal_storage: 0,
      remaining_account_storage: 0,
      is_upload_failed: false,
      message_modal_show: false,
      show_error_detail: false,
      error_delete_data: null,
      // Google Drive
      isDriveStorage: false,
      driveFolderId: null,
      filterDrive: {
        sortDrive: "",
        searchDrive: "",
      },
      nextPagetoken: null,
      driveUsage: {
        limit: 0.0,
        usage: 0.0,
      },
      driveMedia: [],
      selected_ids_drive: [],
      convert_selected_media_drive: [],
      loading_get_drive: false,
      loading_get_drive_refresh: false,
      is_loading_btn: false,
      modal_upload_drive: false,
      message_force_modal_show: false,
      loading_remove_media: false,
      message_force_modal_drive_show: false,
      error_delete_drive_data: null,
      selected_delete_drive_media: null,
    };
  },

  methods: {
    resetModal() {
      this.new_media = {
        name: "",
        link: "",
      };

      this.edit_modal = false;
    },
    parseDriveSelected() {
      if (this.selected_ids_clone.length > 0) {
        this.is_loading_btn = true;
        this.$axios
          .post(MEDIA.DRIVE_MEDIAS, { media_ids: this.selected_ids_clone })
          .then(({ data }) => {
            if (data.applicationSystem.code == 0) {
              const medias = data.data;
              if (medias == null || medias.length == 0) {
                this.is_loading_btn = false;
              } else {
                let selected_ids = collect(this.selected_ids_clone).unique();
                let count = 0;
                collect(medias).map((item) => {
                  count++;
                  selected_ids = selected_ids.filter((val) => val != item.id);
                  this.selected_ids_drive = collect(this.selected_ids_drive)
                    .push(item.values.id)
                    .all();
                  if (count == medias.length) {
                    this.is_loading_btn = false;
                    this.selected_ids_clone = selected_ids.all();
                  }
                });
              }
            } else {
              this.is_loading_btn = false;
            }
          });
      }
    },
    preview(media, is_media_integration = false) {
      if (is_media_integration) {
        window.open(media.webViewLink, "_blank");
      } else {
        if (["document", "link"].indexOf(media.type) > -1) {
          if (media.type == "link" && !this.isEmpty(media.link)) {
            window.open(media.link, "_blank");
          } else if (
            media.type == "document" &&
            !this.isEmpty(media.file) &&
            !this.isEmpty(media.file.link)
          ) {
            this.openDocument(media.file.link);
          }
        } else if (this.preview_types.indexOf(media.type) > -1) {
          this.is_preview = true;
        }
      }
    },
    onSelectedFile() {
      const file = this.$refs.upload_file.files[0];
      this.file_upload = {
        name: file.name,
        size: file.size,
      };
    },
    isSelected(media_id) {
      return this.selected_ids_clone.indexOf(media_id) > -1 ? true : false;
    },
    getPersonalMedias(refresh = false) {

      this.selected_media = null;

      if (refresh) {
        this.dataProvider.page["current"] = 1;
        this.loading_get_medias_refresh = true;
      } else {
        this.loading_get_medias = true;
      }

      if (!this.isEmpty(this.types)) {
        this.dataProvider["criterion"] = this.convertToCriterionDataProvider(
          _.cloneDeep(this.dataProvider.criterion),
          {
            criteria: "type",
            operator: "EQ",
            value: this.types.join(","),
            custom: true,
          }
        );
      }

      this.$axios
        .post(MEDIA.GET_ALL, {
          dataProvider: JSON.stringify(this.dataProvider),
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let medias = data.data.data;

            if (!refresh) {
              medias = collect(this.medias).merge(medias).toArray();
            }

            this.medias = medias;
            this.views = this.medias;
            this.dataProvider = data.data.dataProvider;
          } else {
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: "is-danger",
            });
          }

          if (refresh) {
            this.loading_get_medias_refresh = false;
          } else {
            this.loading_get_medias = false;
          }
        })
        .catch(() => {
          this.loading_get_medias_refresh = false;
          this.loading_get_medias = false;
        });
    },
    getPTMedias(refresh = false) {

      if (this.isEmpty(this.account)) {
        return;
      }

      this.selected_media = null;

      if (refresh) {
        this.dataProvider.page["current"] = 1;
        this.loading_get_medias_refresh = true;
      } else {
        this.loading_get_medias = true;
      }

      if (!this.isEmpty(this.types)) {
        this.dataProvider["criterion"] = this.convertToCriterionDataProvider(
          _.cloneDeep(this.dataProvider.criterion),
          {
            criteria: "type",
            operator: "EQ",
            value: this.types.join(","),
            custom: true,
          }
        );
      }

      this.$axios
        .post(MEDIA.GET_ALL, {
          dataProvider: JSON.stringify(this.dataProvider),
          ua: true,
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let medias = data.data.data;

            if (!refresh) {
              medias = collect(this.PTMedias).merge(medias).toArray();
            }

            this.PTMedias = medias;
            this.viewsPT = this.PTMedias;
            this.dataProvider = data.data.dataProvider;
          } else {
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: "is-danger",
            });
          }

          if (refresh) {
            this.loading_get_medias_refresh = false;
          } else {
            this.loading_get_medias = false;
          }
        })
        .catch(() => {
          this.loading_get_medias_refresh = false;
          this.loading_get_medias = false;
        });
    },
    getGoogleDriveUsage() {
      this.$axios.get(MEDIA.DRIVE_USAGE).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          this.driveUsage = data.data;
        }
      });
    },
    getGoogleDriveMedia(folderId = "", refresh = false) {

      if (folderId != "") {
        this.driveFolderId = folderId;
      }

      this.loading_get_drive = true;

      this.$axios
        .post(MEDIA.DRIVE(folderId), {
          nextPageToken: this.nextPagetoken,
          type: this.types,
          sort: this.filterDrive.sortDrive,
          search: this.filterDrive.searchDrive,
        })
        .then(({ data }) => {
          this.loading_get_drive = false;
          if (data.applicationSystem.code == 0) {
            let drive = data.data;
            if (data.prevFolder != null) {
              const prevFolder = data.prevFolder;
              collect(drive)
                .prepend({ id: prevFolder, name: "Kembali...", type: "back" })
                .all();
            }
            this.driveMedia = drive;
          } else {
            if (this.isConnectedDrive) {
              this.$buefy.toast.open({
                message: data.applicationSystem.message,
                type: "is-danger",
              });
            }
          }
        })
        .catch(() => {
          this.loading_get_drive = false;
          this.loading_get_drive_refresh = false;
        });
    },
    selectDriveMedia(id) {

      if (this.selected_ids_drive.indexOf(id) === -1) {
        collect(this.selected_ids_drive).push(id).all();
      } else {
        _.remove(this.selected_ids_drive, (value) => value == id);
      }
    },
    selectMedia(index, media) {
      let cloned_media = _.cloneDeep(media);
      cloned_media["index"] = index;
      this.selected_media = cloned_media;
    },
    openFolder(media_index) {
      const media = this.medias[media_index];
      if (media.file_type == "file") {
        return;
      }

      this.active_media = media;
      this.views = this.active_media.medias;
    },
    backToHome() {
      this.active_media = null;
      this.views = this.medias;
    },
    addMedia() {

      let postData = _.cloneDeep(this.new_media);

      if (this.loading_create_media) {
        return;
      }

      if (this.menu == 1) {
        postData["ua"] = true;
      }

      let url = postData.link;
      if (!this.isEmpty(url)) {
        let regExp =
          /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        let match = url.match(regExp);
        if (match && match[2].length == 11) {
        } else {
          toast.danger("URL tidak sesuai");
          return;
        }
      }

      this.loading_create_media = true;

      this.$axios
        .post(MEDIA.ADD, postData)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            this.medias = data.data.data;
            this.views = this.medias;

            this.resetModal();

            this.track("media", "add_new_media", null, "u");
          } else {
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: "is-danger",
            });
          }

          this.loading_create_media = false;
          this.$store.dispatch("getStorageUsed");
        })
        .catch(() => {
          this.loading_create_media = false;
        });
    },
    upload(file = null) {
      let group_id = "";

      this.loading_upload = true;

      var formData = new FormData();
      file = !this.isEmpty(file) ? file : this.$refs.upload_file.files[0];

      if (this.active_media !== null) {
        group_id = this.active_media.id;
      }

      if (!this.isEmpty(file)) {
        formData.append("file", file);
      } else {
        this.$buefy.toast.open({
          message: "Berkas tidak valid",
          type: "is-danger",
          duration: 5000,
        });
        this.resetModal();
        this.loading_upload = false;
        this.progress_upload = null;
        return;
      }

      let new_storage_used =
        (this.menu == 1
          ? parseFloat(this.account_storage_used)
          : parseFloat(this.personal_storage_used)) + parseFloat(file.size);
      let storage_limit =
        this.menu == 1
          ? this.account.university.activePackage.storageLimit
          : this.auth.activePackage.storageLimit;

      if (parseFloat(storage_limit) < parseFloat(new_storage_used)) {
        if (!this.isEmpty(this.account) && this.menu == 0) {
          const remaining_personal_storage =
            this.auth.activePackage.storageLimit - this.personal_storage_used;
          this.remaining_personal_storage = remaining_personal_storage;
          if (remaining_personal_storage <= 0) {
            this.message_warning = "habis";
          } else {
            this.message_warning = "hampir";
          }
        } else if (!this.isEmpty(this.account) && this.menu == 1) {
          if (["LECTURER", "STUDENT", "ADMIN"].indexOf(this.account.type) > -1) {
            const remaining_account_storage =
              this.account.university.activePackage.storageLimit -
              this.account_storage_used;
            this.remaining_account_storage = remaining_account_storage;
            if (remaining_account_storage <= 0) {
              this.message_warning = "habis";
            } else {
              this.message_warning = "hampir";
            }
          } else {
            this.message_warning = "habis";
          }
        }

        this.show_message = true;
        this.resetModal();
        this.loading_upload = false;
        this.progress_upload = null;
        this.is_upload_failed = true;
        return;
      }

      formData.append("group_id", group_id);

      if (this.menu == 1) {
        formData.append("ua", true);
      }

      let token = this.$route.query.t;
      token = this.isEmpty(token) ? this.$cookies.get("token") : token;

      if (token) {
        let no_need_encode = false;
        try {
          no_need_encode = helpers.parseJwt(token);
          no_need_encode =
            !helpers.isEmpty(no_need_encode) &&
            !helpers.isEmpty(no_need_encode.username) &&
            !helpers.isEmpty(no_need_encode.appid);
        } catch (e) {}

        token = no_need_encode ? token : helpers.encodeToken(token);
      }

      axios
        .post(`${process.env.API_URL}${MEDIA.UPLOAD}`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            this.progress_upload = percentCompleted;
          },
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            this.is_upload_failed = false;
            if (this.menu == 0) {
              this.getMedias(true);

              this.track("media", "upload_media", null, "u");
            } else {
              this.getMedias(true);
            }

            this.file_upload = {
              name: "",
              size: "",
            };

            this.resetModal();
            this.$store.dispatch("getStorageUsed");
            if (
              (parseFloat(new_storage_used) / parseFloat(storage_limit)) *
                100 >=
              90
            ) {
              this.message_warning = "hampir";
              if (!this.isEmpty(this.account) && this.menu == 0) {
                const remaining_personal_storage =
                  this.auth.activePackage.storageLimit -
                  this.personal_storage_used;
                this.remaining_personal_storage = remaining_personal_storage;
                if (remaining_personal_storage <= 0) {
                  this.message_warning = "habis";
                } else {
                  this.message_warning = "hampir";
                }
              } else if (!this.isEmpty(this.account) && this.menu == 1) {
                if (
                  ["LECTURER", "STUDENT", "ADMIN"].indexOf(this.account.type) > -1
                ) {
                  const remaining_account_storage =
                    this.account.university.activePackage.storageLimit -
                    this.account_storage_used;
                  this.remaining_account_storage = remaining_account_storage;
                  if (remaining_account_storage <= 0) {
                    this.message_warning = "habis";
                  } else {
                    this.message_warning = "hampir";
                  }
                } else {
                  this.message_warning = "habis";
                }
              }
              this.show_message = true;
            }
            setTimeout(() => {
              this.progress_upload = null;
            }, 2000);
          } else {
            /*this.$buefy.notification.open({
            message: data.applicationSystem.message,
            type: 'is-danger',
            duration: 7000
          });*/
            this.is_upload_failed = true;

            this.new_media = {
              name: "",
              link: "",
            };
          }

          this.loading_upload = false;
        })
        .catch(() => {
          this.loading_upload = false;
        });
    },
    submitSelected() {

      let selected_medias = this.filterMedias(this.available_medias);

      let new_selected_medias = selected_medias;

      if (this.selected_media_drive.length > 0) {
        this.$axios
          .post(MEDIA.DRIVE_TO_MEDIA, { medias: this.selected_media_drive })
          .then(({ data }) => {
            new_selected_medias = collect(selected_medias)
              .merge(data.data)
              .all();
            this.plucktoMediaCatcher(new_selected_medias);
          });
      } else {
        this.plucktoMediaCatcher(new_selected_medias);
      }
    },
    plucktoMediaCatcher(selected_medias) {

      if (!this.isEmpty(this.max) && selected_medias.length > this.max) {
        toast.danger(`Maksimal hanya ${this.max} media`);
        return;
      }

      this.selected_medias = [];

      if (this.isEmpty(selected_medias)) {
        this.$buefy.toast.open({
          message: "Pilih salah satu berkas",
          type: "is-warning",
        });
      } else if (!this.isEmpty(selected_medias)) {
        this.mediaCatcher(selected_medias);
      } else {
        this.$buefy.toast.open({
          message: "Berkas tidak didukung",
          type: "is-danger",
        });
      }
    },
    removeDriveMedia(media, force = false) {

      if (!force) {
        this.selected_delete_drive_media = media;
      }

      let url = MEDIA.DELETE_DRIVE_MEDIA(
        force ? this.selected_delete_drive_media.id : media.id
      );

      if (force) {
        url = `${url}?force=1`;
      }

      this.$axios.post(url).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          this.getGoogleDriveMedia();
          this.$buefy.toast.open({
            message: data.applicationSystem.message,
            type: "is-success",
          });
          this.selected_delete_drive_media = null;
          this.message_force_modal_drive_show = false;
          this.error_delete_drive_data = null;
        } else {
          if (data.data.totalMediaUsedInActivePeriods === 0) {
            this.error_delete_drive_data = data.data;
            this.message_force_modal_drive_show = true;
          } else {
            this.error_delete_data = data.data;
            this.message_modal_show = true;
          }
        }
      });
    },
    removeMedia(_e, force = false) {
      let selected_media = this.selected_media;

      if (this.loading_remove_media) {
        return;
      }

      this.loading_remove_media = true;

      if (!this.isEmpty(selected_media)) {
        let postData = {};
        if (this.menu == 1) {
          postData["ua"] = true;
        }

        let url = MEDIA.DESTROY(selected_media.id);
        if (force) {
          url = `${url}?force=1`;
        }

        this.$axios
          .post(url, postData)
          .then(({ data }) => {
            if (data.applicationSystem.code == 0) {
              this.$buefy.toast.open({
                message: data.applicationSystem.message,
              });

              if (this.menu == 0) {
                this.getMedias(true);
              } else {
                this.getMedias(true);
              }

              this.message_force_modal_show = false;
              this.message_modal_show = false;
            } else {
              this.error_delete_data = data.data;

              if (data.data.totalMediaUsedInActivePeriods === 0) {
                this.message_force_modal_show = true;
              } else {
                this.message_modal_show = true;
              }
            }

            this.loading_get_medias_refresh = false;
            this.loading_remove_media = false;
            this.$store.dispatch("getStorageUsed");
          })
          .catch(() => {
            this.loading_get_medias_refresh = false;
            this.loading_remove_media = false;
          });
      }
    },
    markToggle(media_id) {
      const media = collect((this.menu == 0) ? this.medias : this.PTMedias).where("id", "==", media_id).first();
      let available_ids = this.available_ids;

      if (media !== null && available_ids.indexOf(media.id) > -1) {
        this.selected_medias = collect(this.selected_medias)
          .filter((media) => media.id !== media_id)
          .toArray();
        this.selected_ids_clone = this.selected_ids_clone.filter(
          (id) => id != media_id
        );
      } else {
        if (this.multiple) {
          this.selected_medias = collect(this.selected_medias)
            .push(media)
            .unique("id")
            .toArray();
        } else {
          this.selected_medias = [media];
        }
      }
    },
    filterMedias(medias) {
      medias = collect(medias);

      if (!this.isEmpty(medias) && !this.isEmpty(this.types)) {
        medias = medias.filter((m) => {
          if (this.types.indexOf(m.type) > -1) {
            return true;
          }

          return false;
        });
      }

      if (!this.isEmpty(this.only_extensions) && this.only_extensions.length > 0) {
        medias = medias.filter((m) => {
          if (this.only_extensions.indexOf(m.extension) > -1) {
            return true;
          }

          return false;
        });
      }

      return medias.toArray();
    },
    moveTo(media_id, source) {
      if (this.isEmpty(source)) return;
      if (this.isEmpty(this.account)) return;

      this.$buefy.dialog.confirm({
        message: "Apakah anda yakin akan memindahkan berkas ini?",
        cancelText: "Batal",
        confirmText: "Saya yakin",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          const { data } = await this.$axios
            .post(MEDIA.MOVE(media_id), {
              to: source,
            });

          if (data.applicationSystem.code == 0) {
            await setTimeout(() => {}, 500);
            this.$store.dispatch("getStorageUsed");
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
            });

            let medias = data.data.data;

            this.medias = medias;
            this.views = this.medias;
            this.dataProvider = data.data.dataProvider;
          } else {
            this.$buefy.toast.open({
              message: data.applicationSystem.message,
              type: "is-danger",
            });
          }
        },
      });
    },
    getMedias(refresh = false, getAll = false) {
      if (getAll) {
        this.getPersonalMedias(refresh);
        this.getPTMedias(refresh);
        this.getGoogleDriveMedia();
      } else {
        if (this.menu == 0) {
          this.getPersonalMedias(refresh);
        } else if (this.menu == 1) {
          this.getPTMedias(refresh);
        } else {
          this.getGoogleDriveMedia();
        }
      }
    },
    uploadingFile(file) {
      if (file.size > 104857600) {
        this.$buefy.toast.open({
          message: "Ukuran berkas maksimal 100MB",
          type: "is-danger"
        });

        return;
      }

      this.file_upload = {
        name: file.name,
        size: file.size,
      };

      this.upload(file);
    },
    uploadingFileDrive(file = null) {

      if (file.size > 104857600) {
        this.$buefy.toast.open({
          message: "Ukuran berkas maksimal 100MB",
          type: "is-danger"
        });

        return;
      }

      this.loading_upload = true;

      let token = this.$route.query.t;
      token = this.isEmpty(token) ? this.$cookies.get("token") : token;

      if (token) {
        let no_need_encode = false;
        try {
          no_need_encode = helpers.parseJwt(token);
          no_need_encode =
            !helpers.isEmpty(no_need_encode) &&
            !helpers.isEmpty(no_need_encode.username) &&
            !helpers.isEmpty(no_need_encode.appid);
        } catch (e) {}

        token = no_need_encode ? token : helpers.encodeToken(token);
      }

      var formData = new FormData();
      file = !this.isEmpty(file) ? file : this.$refs.upload_file.files[0];

      if (!this.isEmpty(file)) {
        formData.append("file", file);
      } else {
        this.$buefy.toast.open({
          message: "Berkas tidak valid",
          type: "is-danger",
          duration: 5000,
        });

        this.loading_upload = false;
        this.progress_upload = null;
        this.modal_upload_drive = false;
        return;
      }

      if (!this.isEmpty(this.driveFolderId)) {
        formData.append("parent_id", this.driveFolderId);
      }

      this.$axios
        .post(MEDIA.DRIVE_UPLOAD, formData, {
          headers: {
            "Content-type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            this.progress_upload = percentCompleted;
          },
        })
        .then(({ data }) => {
          this.getGoogleDriveMedia(
            !this.isEmpty(this.driveFolderId) ? this.driveFolderId : "",
            false
          );

          this.loading_upload = false;
          setTimeout(() => {
            this.modal_upload_drive = false;
            this.progress_upload = null;
          }, 2000);
        });
    },
    openFormUpgrade(param) {
      this.show_detail = false;
      this.show_upgrade = true;
    },
    closeDetailStorage(param) {
      this.show_detail = param;
    },
    closeFormUpgrade(param) {
      this.show_upgrade = param;
    },
    sendMessage(text) {
      let message = "";
      if (this.isEmpty(this.account)) {
        return;
      }
      if (!["REKTOR"].indexOf(this.account.type) > -1) {
        this.show_upgrade = true;
        return;
      }
      if (["ADMIN"].indexOf(this.account.type) > -1) {
        window.location.href = "/edlink-pro.php";
        return;
      }
      this.sending_message = true;
      if (["LECTURER", "STUDENT"].indexOf(this.account.type) > -1) {
        if (this.message_warning == "habis") {
          message =
            "Ruang penyimpanan Perguruan Tinggi sudah habis, tolong pihak Perguruan Tinggi untuk upgrade ke Edlink Pro ";
        }
        if (this.message_warning == "hampir") {
          message =
            "Ruang penyimpanan Perguruan Tinggi hampir habis, tolong pihak Perguruan Tinggi untuk upgrade ke Edlink Pro ";
        }
      }

      this.$axios
        .post(MESSAGE.SEND_TO_ADMIN(), {
          message: message,
        })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let messages = data.data.data;
            this.$router.push({ path: "messages", params: { cid: "123" } });
          }
          this.sending_message = false;
          this.show_message = false;
          return;
        })
        .catch(() => {
          this.sending_message = false;
          this.show_message = false;
        });
    },
    getQuotaUsed() {

      if (this.isEmpty(this.account.university)) {
        return;
      }
      this.show_message = false;
      this.show_upgrade = false;
      this.show_detail = true;
      this.loading_detail_quota_pt_used = true;

      this.$axios
        .post(UNIVERSITY.GET_QUOTA_USED(this.account.university.id))
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            this.detail_quota_pt_used["storage_used"] = !this.isEmpty(
              data.data.storage
            )
              ? data.data.storage
              : 0;
            this.detail_quota_pt_used["class_used"] = !this.isEmpty(
              data.data.classUsed
            )
              ? data.data.classUsed
              : 0;
            this.detail_quota_pt_used["conference_used"] = !this.isEmpty(
              data.data.conferencesUsed
            )
              ? data.data.conferencesUsed
              : 0;
            this.detail_quota_pt_used["storage_detail"] = !this.isEmpty(
              data.data.storageDetail
            )
              ? data.data.storageDetail
              : 0;
          }
          this.loading_detail_quota_pt_used = false;
        })
        .then(() => {
          this.loading_detail_quota_pt_used = false;
        });
    },
    closeKirimEmailForm() {
      this.show_upgrade = false;
    },
  },
};
</script>

<style>
.selected {
  background-color: #f5f5f5;
  border-radius: 3px;
}

.upload-draggable {
  width: 100%;
}

.upload-modal .b-tabs ul {
  margin: 0 !important;
}

/*.button-setting {
    position: absolute;
    top: 5px;
  }

  .button-setting.left {
    left: 5px;
  }

  .button-setting.right {
    right: 5px;
  }*/
</style>
